const PUBLIC_PARAM = 'p=1';

export function getShareUrl(baseUrl: string): string {
  const hashIndex = baseUrl.indexOf('#');
  const urlWithoutHash = hashIndex >= 0 ? baseUrl.substring(0, hashIndex) : baseUrl;
  const hash = hashIndex >= 0 ? baseUrl.substring(hashIndex) : '';
  const separator = urlWithoutHash.includes('?') ? '&' : '?';
  return `${urlWithoutHash}${separator}${PUBLIC_PARAM}${hash}`;
}

export function getWorkspaceUrl(shareUrl?: string): string {
  if (shareUrl) return shareUrl;
  const { origin, pathname, hash } = window.location;
  const resourcePath = pathname.split('#')[0];
  return `${origin}${resourcePath}${hash || ''}`;
}
